import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import DashboardLayout from './layouts/DashboardLayout';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import DashboardPage from './pages/DashboardPage';
import ClientsPage from './pages/ClientsPage';
import SessionsPage from './pages/SessionsPage';
import NotesPage from './pages/NotesPage';
import SettingsPage from './pages/SettingsPage';
import MessagesPage from './pages/messages/MessagesPage';
import AnalyticsDashboard from './pages/analytics/AnalyticsDashboard';
import AvailabilityPage from './pages/availability/AvailabilityPage';
import PaymentsPage from './pages/settings/PaymentsPage';
import NotificationSettings from './pages/settings/NotificationSettings';
import { SessionHistoryPage } from './pages/SessionHistoryPage';
import { RegistrationWizard } from './pages/onboarding/RegistrationWizard';
import { RegistrationSuccess } from './pages/onboarding/RegistrationSuccess';
import { VideoSessionPage } from './pages/session/VideoSessionPage';
import { SessionNotesPage } from './pages/session/SessionNotesPage';

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />

        {/* Onboarding routes */}
        <Route path="/onboarding" element={<RegistrationWizard />} />
        <Route path="/onboarding/success" element={<RegistrationSuccess />} />

        {/* Video session route */}
        <Route
          path="/session/:bookingId"
          element={
            <ProtectedRoute requiredRole="therapist">
              <VideoSessionPage />
            </ProtectedRoute>
          }
        />

        {/* Session notes route */}
        <Route
          path="/sessions/:bookingId/notes"
          element={
            <ProtectedRoute requiredRole="therapist">
              <SessionNotesPage />
            </ProtectedRoute>
          }
        />

        {/* Protected routes */}
        <Route
          path="/"
          element={
            <ProtectedRoute requiredRole="therapist">
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="analytics" element={<AnalyticsDashboard />} />
          <Route path="clients" element={<ClientsPage />} />
          <Route path="sessions" element={<SessionsPage />} />
          <Route path="session-history" element={<SessionHistoryPage />} />
          <Route path="notes" element={<NotesPage />} />
          <Route path="messages" element={<MessagesPage />} />
          <Route path="availability" element={<AvailabilityPage />} />
          <Route path="payments" element={<PaymentsPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route path="settings/notifications" element={<NotificationSettings />} />
        </Route>

        {/* Catch all redirect */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
